import $ from '../tools/Dom';
import { loadLottie } from '../lib/async-bundles';

export default el => {
    const dom = $(el);
    let lottie;
    const items = dom.find('[data-item]');
    const animations = [];

    const onSegmentStart = item => {
        $(item).addClass('js-is-loaded');
    };

    const startLottie = () => {
        items.each((item, i) => {
            const container = $(item).find('[data-animate]');
            if (container.length) {
                animations[i] = lottie.loadAnimation({
                    container: container.get(0),
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: `/animations/${$(item).data('item')}_data.json`
                });
                animations[i].addEventListener('DOMLoaded', onSegmentStart.bind(null, item));
            }
        });
    };

    const init = () => {
        loadLottie(Lottie => {
            lottie = Lottie;
            startLottie();
        });
    };

    const destroy = () => {
        animations.each(animation => {
            animation.removeEventListener('DOMLoaded', onSegmentStart);
        });
    };

    return {
        init,
        destroy
    };
};
